module.exports = __webpack_public_path__ + "img/0a714b7.png";